import { GlLink } from '@gitlab/ui';
import { STATUS_CLOSED, STATUS_MERGED } from '~/issues/constants';
import SafeHtml from '~/vue_shared/directives/safe_html';
import { s__, n__ } from '~/locale';
export default {
    name: 'MRWidgetRelatedLinks',
    directives: {
        SafeHtml
    },
    components: {
        GlLink
    },
    props: {
        relatedLinks: {
            type: Object,
            required: true
        },
        state: {
            type: String,
            required: false,
            default: ''
        },
        showAssignToMe: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    computed: {
        closesText () {
            if (this.state === STATUS_MERGED) {
                return s__('mrWidget|Closed');
            }
            if (this.state === STATUS_CLOSED) {
                return s__('mrWidget|Did not close');
            }
            return n__('mrWidget|Closes issue', 'mrWidget|Closes issues', this.relatedLinks.closingCount);
        },
        assignIssueText () {
            if (this.relatedLinks.unassignedCount > 1) {
                return s__('mrWidget|Assign yourself to these issues');
            }
            return s__('mrWidget|Assign yourself to this issue');
        },
        shouldShowAssignToMeLink () {
            return this.relatedLinks.unassignedCount && this.relatedLinks.assignToMe && this.showAssignToMe;
        }
    }
};
